import { render, staticRenderFns } from "./Zoom2uKeys.vue?vue&type=template&id=2612cfa0&"
import script from "./Zoom2uKeys.vue?vue&type=script&lang=js&"
export * from "./Zoom2uKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2612cfa0')) {
      api.createRecord('2612cfa0', component.options)
    } else {
      api.reload('2612cfa0', component.options)
    }
    module.hot.accept("./Zoom2uKeys.vue?vue&type=template&id=2612cfa0&", function () {
      api.rerender('2612cfa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamCarriers/components/Zoom2uKeys.vue"
export default component.exports